import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles(theme => ({
  coachProfileCardsContainer: {
    margin: '2rem auto 6rem',
    maxWidth: '832px',
    padding: '0 1rem',
  },
  emptyStateContent: {
    padding: theme.spacing(4, 2),
  },
  launchIcon: {
    fontSize: '0.8rem',
    margin: '10px 0 10px 5px',
  },
  analyticsCardContainer: {
    padding: '2rem',
  },
}))
